/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Comment,
  CommentReply,
  EntityId,
  List,
  OrganizationMember,
  PostCommentReplySchema,
  PostCommentSchema,
  UpdateCommentSchema,
} from "./data-contracts";

/**
 * @description Returns a paginated list of comments posted on the change request, optionally filtered by status, target page, or author. Comments can be anchored to a specific page or be general change-request-level comments. Use this to read the review discussion before responding. To fetch replies to a comment, use the comment replies endpoint.
 * @tags change-request-comments
 * @name ListCommentsInChangeRequest
 * @summary List all top-level comments in a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
 * @secure
 */

// @ts-ignore
export const listCommentsInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * When provided, only comments with the given status are returned. Defaults to "all".
     * @default "all"
     */
    status?: "all" | "open" | "resolved";
    /** The target page of the comment */
    targetPage?: string;
    /** User IDs to filter queried comments on */
    authors?: string[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Comment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Posts a new top-level comment on the change request. Comments can be general or anchored to a specific page and inline location within the change request content. Use this to provide review feedback, ask questions, or flag issues. To reply to an existing comment, use the comment replies endpoint instead.
 * @tags change-request-comments
 * @name PostCommentInChangeRequest
 * @summary Post a new comment on a change request
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
 * @secure
 */

// @ts-ignore
export const postCommentInChangeRequest: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: PostCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
  method: "post",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a specific comment from a change request, including its content, author, and anchor location. Use this when you have a comment ID (e.g., from a notification or list) and need its full details.
 * @tags change-request-comments
 * @name GetCommentInChangeRequest
 * @summary Get a single comment from a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const getCommentInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name DeleteCommentInChangeRequest
 * @summary Delete a change request comment
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const deleteCommentInChangeRequest: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the body or status of an existing change request comment. Use this to edit the text of a comment you previously posted, or to resolve/reopen a comment thread. Only the comment author or space admins can update a comment.
 * @tags change-request-comments
 * @name UpdateCommentInChangeRequest
 * @summary Update the content or status of a change request comment
 * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const updateCommentInChangeRequest: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "put",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of replies to a specific top-level comment in a change request. Use this to read the full thread of a review discussion on a particular comment before adding a reply.
 * @tags change-request-comments
 * @name ListCommentRepliesInChangeRequest
 * @summary List all replies to a change request comment
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const listCommentRepliesInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CommentReply[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Adds a reply to an existing comment thread on a change request. Use this to respond to review feedback or continue a discussion on a specific comment. To start a new top-level comment rather than replying, use the change request comments endpoint.
 * @tags change-request-comments
 * @name PostCommentReplyInChangeRequest
 * @summary Post a reply to a change request comment
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const postCommentReplyInChangeRequest: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: PostCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
  method: "post",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a specific reply within a change request comment thread. Use this when you have a reply ID and need its full content and author details.
 * @tags change-request-comments
 * @name GetCommentReplyInChangeRequest
 * @summary Get a single reply to a change request comment
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const getCommentReplyInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the body of an existing reply in a change request comment thread. Use this to correct or amend a reply you previously posted. Only the reply author or space admins can update a reply.
 * @tags change-request-comments
 * @name UpdateCommentReplyInChangeRequest
 * @summary Update the content of a change request comment reply
 * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const updateCommentReplyInChangeRequest: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "put",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name DeleteCommentReplyInChangeRequest
 * @summary Delete a change request comment reply
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const deleteCommentReplyInChangeRequest: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of organization members who have posted at least one comment in the change request. Use this to identify who is actively engaged in the review discussion before adding or directing comments.
 * @tags change-request-comments, critical
 * @name ListCommentersInChangeRequest
 * @summary List all users who have commented in a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/commenters
 * @secure
 */

// @ts-ignore
export const listCommentersInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/commenters",
  method: "get",
  streaming: false,
  tags: ["change-request-comments", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};
